import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const navigate = useNavigate();

    const [Email, setEmail] = useState('')
    const [Password, setpassword] = useState('')
    const [Cpassword, setcpassword] = useState('')

    // const data = [{ email, password, cpassword }]

    const submitData = async (e) => {
        e.preventDefault();

        const res = await fetch('/login', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ Email, Password, Cpassword })
        });
        const data = await res.json();
        console.log(data)

        if (res.status === 422 || !data) {
            alert('Invalid Login')

        } else {

            if (Password === Cpassword) {
                console.log("Login Succsessfull")
                alert("Login Succsessfull")
                navigate('/')
            }
            else {
                alert("Password Not Match")
                navigate('/login')
            }


        }

    }


    // const generatePassaord = () => {
    //     let pass = ''
    //     let str = 'qwertyuioplkjhgfdsazxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM1234567890~!@#$%^&*'

    //     for (let i = 1; i <= 10; i++) {
    //         let char = Math.floor(Math.random()
    //             * str.length + 1);

    //         pass += str.charAt(char)
    //     }

    //     return pass;
    // }


    const guestLogin = (e) => {
        e.preventDefault()
        setEmail("hari@example.com")
        // const a = generatePassaord()

        setpassword('12345678')
        setcpassword('12345678')

    }


    return (
        <div className='container-fluid login '>
            <div className='row p-2 mt-4'>

                <div className='col-10  signup_left p-3 ' style={{
                    borderRadius: '.7rem 0 0 .7rem'
                }}>
                    <form style={{
                        padding: '1rem',
                        lineHeight: '3rem'
                    }}>
                        <center><h2 className='mb-4'>Login Now</h2></center>

                        <div className="form-group">
                            <label for="exampleInputEmail1">Email address</label>
                            <input type="email"
                                name='email'
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                value={Email}
                                className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email" />

                        </div>
                        <div className="form-group">
                            <label for="exampleInputPassword1">Password</label>
                            <input type="password"
                                name='password'
                                onChange={(e) => setpassword(e.target.value)}
                                required

                                value={Password}
                                className="form-control" id="exampleInputPassword1" placeholder="Password" />
                        </div>

                        <div className="form-group">
                            <label for="exampleInputPassword1"> Confirm Password</label>
                            <input type="password"
                                name='cpassword'
                                onChange={(e) => setcpassword(e.target.value)}
                                required
                                value={Cpassword}
                                className="form-control" id="exampleInputPassword1" placeholder="Password" />
                        </div>

                        <button onClick={submitData} style={{ marginTop: '.5rem' }} type="submit" className="btn btn-primary">Login</button>&nbsp;
                        <button onClick={guestLogin} style={{ marginTop: '.5rem' }} type="submit" className="btn btn-primary">Guest Login</button>
                        <p style={{ marginTop: '.5rem' }}>Login with Other</p>

                        <button
                            //  onClick={signUpwithgoogle}
                            style={{ cursor: 'pointer', border: 'none', backgroundColor: 'milk', borderRadius: '.5rem', color: 'green', width: '250px', textDecoration: 'none' }} > <i class="fa fa-google-plus" style={{
                                fontSize: '1.5rem', color: 'red',
                                padding: '.5rem', cursor: 'pointer'
                            }}></i> Sign-in With Google
                        </button><br /><br />
                        <br /><br />


                    </form>

                </div>
            </div>
        </div>

    )
}

export default Login;
